import * as React from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { getFormStyles, SideDrawer } from '@sales-center/components'
import { useData } from '../hooks/useData'
import CircularProgress from '@mui/material/CircularProgress'
import Divider from '@mui/material/Divider'
import Button from '@mui/material/Button'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization'

interface Props {
  onClose: () => void
  open: boolean
}

export const Profile: React.FC<Props> = (props: Props) => {
  const { open, onClose } = props

  const { loading, success, currentUser, salesTeamsForUser } = useData()
  const { isAdmin } = useSelector(selectCurrentUser)
  const styles = getFormStyles()
  return (
    <SideDrawer open={open} title={'PROFILE'} onClose={onClose}>
      {loading && (
        <Box pt={4.8} textAlign="center">
          <CircularProgress />
        </Box>
      )}
      {success && (
        <>
          <Box sx={styles.container}>
            <Box ml={2} mt={4}>
              <Box display="flex" alignItems="center">
                <Typography variant="subtitle2">Employee Type</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography variant="body2">
                  {currentUser?.isExternalUser ? 'Mapped' : 'Unmapped'}
                </Typography>
              </Box>
            </Box>

            <Box ml={2} mt={2}>
              <Box display="flex" alignItems="center">
                <Typography variant="subtitle2">Name</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography variant="body2">{currentUser?.fullName}</Typography>
              </Box>
            </Box>

            <Box ml={2} mt={2}>
              <Box display="flex" alignItems="center">
                <Typography variant="subtitle2">Login Id</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography variant="body2">
                  {currentUser?.emailAddress}
                </Typography>
              </Box>
            </Box>

            <Box ml={2} mt={2}>
              <Box display="flex" alignItems="center">
                <Typography variant="subtitle2">Role</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography variant="body2">{currentUser?.roleName}</Typography>
              </Box>
            </Box>

            <Box ml={2} mt={2}>
              <Box display="flex" alignItems="center">
                <Typography variant="subtitle2">Sales Teams</Typography>
              </Box>
              {isAdmin ? (
                <Typography variant="body2">
                  Admin users have access to all sales teams.
                </Typography>
              ) : (
                <>
                  {salesTeamsForUser.map((st) => (
                    <Box display="flex" key={st.id} alignItems="center">
                      <Typography key={st.id} variant="body2">
                        {st.name} {st.positions.length > 0 ? ' -' : ''}{' '}
                        {st.positions
                          ?.filter(
                            (x) =>
                              x?.id &&
                              currentUser?.salesTeamPositionIds?.includes(
                                x?.id,
                              ),
                          )
                          .map((x) => x.title)
                          .join(', ')}
                      </Typography>
                    </Box>
                  ))}
                </>
              )}
            </Box>
          </Box>
          <Divider />
          <Box sx={styles.footer}>
            <Button variant="outlined" onClick={onClose}>
              Close
            </Button>
          </Box>
        </>
      )}
    </SideDrawer>
  )

  Profile.displayName = 'UserProfile'
}
